<template>
  <ui-ui-button
    v-if="isMainPage"
    class="product-card__button"
    size="medium"
    :resize="true"
    type="primary"
    font-class="body-l-regular"
    mode="link"
    @click="openModal"
  >
    {{ text }}
  </ui-ui-button>
  <div v-else class="button-tape" @click="openModal">
    <div :class="['button', color, 'body-l-regular']">
      {{ text }}
      <div v-if="showTape" class="tape-wrapper">
        <div class="tape">
          <img src="/static/images/markers/tape.svg" alt="tape" />
        </div>
        <span class="last-char">
          {{ promocode }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PromocodesContentItem } from '~/interfaces/constructor';

const route = useRoute();
const isMainPage = ref<boolean>(route?.name && route?.name === 'index');
const { $ymGoalEventPromo } = useNuxtApp();
const config = useRuntimeConfig();
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: '',
  },
  promo: {
    type: Object as () => PromocodesContentItem,
    required: true,
  },
  showTape: {
    type: Boolean,
    default: true,
  },
  ymTag: {
    type: String,
    default: 'Promokody: click na knopku_pokazat promokod',
  },
  order: {
    type: Number,
    default: 0,
  },
});

const promocode = computed(() => {
  return props.promo?.promocode && props.promo.promocode.length > 0
    ? props.promo.promocode.slice(-1)
    : '';
});

function openModal() {
  if (props.promo)
    if (props.promo?.type === 'promocode' || props.promo?.type === 'action') {
      $ymGoalEventPromo(props.ymTag, String(props.promo?.id));
    }
  if (props.promo?.type === 'promocode') {
    const urlModal = new URL(window.location.href);
    urlModal.searchParams.set('coupon', (props.promo?.id).toString());
    if (props.order > 9) {
      urlModal.searchParams.set('order', (props?.order).toString());
    }
    // наш сайт с промо
    window.open(urlModal.href);
    // показываем магазин
    document.location.href =
      (config.public.VITE_CPC_PREFIX || window.location.origin) +
      props.promo?.url;
  } else
    window.open(
      (config.public.VITE_CPC_PREFIX || window.location.origin) +
        props.promo?.url,
      '_blank'
    );
}
</script>
<style scoped lang="scss" src="./ButtonTapeScss.scss" />
